import React, { useRef } from 'react';
import { CSVLink } from 'react-csv';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Tooltip } from '@material-ui/core';
import { GetApp as DownloadIcon } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  submitButton: {
    margin: theme.spacing(2),
    borderRadius: 50,
    minWidth: 36,
    width: 'auto',
    padding: '6px',
    position: 'relative',
  },
}));

export default function SaveButton({ headers, data }) {
  const classes = useStyles();
  const csvLink = useRef();

  const handleDownload = () => {
    csvLink.current.link.click();
  };

  const filename = `data_${Date.now()}.csv`;

  return (
    <>
      <Tooltip title="Download Grid Data">
        <Button
          variant="contained"
          className={classes.submitButton}
          onClick={handleDownload}
        >
          <DownloadIcon />
        </Button>
      </Tooltip>
      <CSVLink
        ref={csvLink}
        headers={headers}
        data={data || []}
        filename={filename}
        target="_blank"
        separator=";"
        enclosingCharacter={'"'}
      />
    </>
  );
}
